module.exports = __webpack_public_path__ + "partner-background.34934e1f040f1408a13f.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/partner-background.jpg
// module id = ../../../../../src/assets/images/backgrounds/partner-background.jpg
// module chunks = styles